import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericCRUDService } from 'src/app/shared/services';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ObservacaoService extends GenericCRUDService {
    
    constructor(http: HttpClient) {
        super(http);
        this.url = `/admin/dio`;
    }

    /**
     * Recupera todas as observações de um DIO
     * @param dioId - ID do DIO
     * @returns Observable com as observações do DIO
     */
    getObservacoesByDio(dioId: string): Observable<any> {
        return this.http.get<any>(`${this.url}/${dioId}/observacoes`);
    }

    /**
     * Cria uma nova observação para um DIO
     * @param observacao - Dados da observação a ser criada
     * @returns Observable com a resposta da criação
     */
    createObservacao(observacao: any): Observable<any> {
        return this.http.post<any>(`${this.url}/${observacao.dioId}/observacoes`, observacao);
    }
}
